import { render, staticRenderFns } from "./StudentActivityTableSelectRowCheckboxCell.vue?vue&type=template&id=43f87e81&scoped=true&"
import script from "./StudentActivityTableSelectRowCheckboxCell.vue?vue&type=script&lang=ts&"
export * from "./StudentActivityTableSelectRowCheckboxCell.vue?vue&type=script&lang=ts&"
import style0 from "./StudentActivityTableSelectRowCheckboxCell.vue?vue&type=style&index=0&id=43f87e81&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43f87e81",
  null
  
)

export default component.exports